<template>
    <section>
        <header v-if="hasVerifiedCustomDomain" class="card-info">
            <div class="card-title">
                <ds-icon class="check-circle-icon" name="check-circle" />
                <div class="card-description">
                    <strong>{{ domain.domainName }}</strong>

                    <p>{{ $options.MESSAGE_CONSTANTS.processVerified }}</p>
                </div>
                <div class="attempt">
                    {{ `Last attempt: ${lastAttempt} hrs` }}
                </div>
            </div>
            <div class="wrap-buttons">
                <ds-text-button
                    data-qa="delete-verified-custom-domain-button-qa"
                    class="remove-domain-button"
                    @click="remove"
                >
                    {{ $options.MESSAGE_CONSTANTS.delete }}
                </ds-text-button>
            </div>
        </header>

        <header v-else class="card-info">
            <section v-if="isPastErrorThreshold">
                <div class="card-title">
                    <ds-icon class="alert-circle-icon" name="alert-triangle" />
                    <div class="card-description">
                        <strong>{{ domain.domainName }}</strong>
                        <p>{{ $options.MESSAGE_CONSTANTS.processUnableToVerify }}</p>
                    </div>
                </div>
                <div class="attempt">
                    {{ `Last attempt: ${lastAttempt} hrs` }}
                </div>
                <div class="wrap-buttons">
                    <ds-text-button
                        data-qa="retry-unable-to-verify-verified-custom-domain-button-qa"
                        class="retry-domain-button"
                        @click="retry"
                    >
                        {{ $options.MESSAGE_CONSTANTS.retry }}
                    </ds-text-button>
                    <ds-text-button
                        class="remove-domain-button"
                        @click="remove"
                    >
                        {{ $options.MESSAGE_CONSTANTS.delete }}
                    </ds-text-button>
                </div>
            </section>

            <section v-else>
                <div class="card-title">
                    <ds-icon class="alert-triangle-icon" name="alert-triangle" />
                    <div class="card-description">
                        <strong>{{ domain.domainName }}</strong>

                        <p>{{ $options.MESSAGE_CONSTANTS.processVerifying }}</p>
                    </div>
                </div>
                <div class="attempt">
                    {{ `Last attempt: ${lastAttempt} hrs` }}
                </div>
                <div class="wrap-buttons">
                    <ds-text-button
                        class="remove-domain-button"
                        @click="remove"
                    >
                        {{ $options.MESSAGE_CONSTANTS.delete }}
                    </ds-text-button>
                </div>
                <div class="card-info-warning">
                    <span class="note-box">
                        {{ $options.MESSAGE_CONSTANTS.note }}
                    </span>
                    <ds-text-button
                        class="retry-domain-button"
                        data-qa="check-custom-domain-button-qa"
                        @click="check"
                    >
                        {{ $options.MESSAGE_CONSTANTS.check }}
                    </ds-text-button>
                </div>
            </section>
        </header>
    </section>
</template>

<script>

export const MESSAGE_CONSTANTS = {
    retry: 'Retry Validation',
    delete: 'Delete Domain',
    processVerifying: 'We are in the process of verifying your domain.',
    processUnableToVerify: 'We were unable to verify your domain.',
    processVerified: 'Your domain has been verified.',
    note: 'It can take 48hrs for your domain to be verified.',
    check: 'Check Status',
};

import moment from 'moment';

export default {
    MESSAGE_CONSTANTS,
    props: {
        domain: {
            type: Object,
            required: true,
        },
    },
    computed: {
        hasVerifiedCustomDomain() {
            if (!this.domain) {
                return false;
            }

            return !!this.domain.setupComplete;
        },
        isPastErrorThreshold() {
            if (this.domain?.createTime && !this.domain?.setupComplete) {
                const createTime = moment(this.domain.createTime);

                if (moment().isAfter(createTime.clone().add(48, 'hours'))) {
                    return true;
                }
            }

            return false;
        },
        lastAttempt() {
            const now = moment(new Date());
            const end = moment(this.domain?.createTime ?? new Date());
            const duration = moment.duration(now.diff(end));

            return Math.round(duration.asHours());
        },
    },
    methods: {
        retry() {
            this.$emit('retry', this.domain);
        },
        remove() {
            this.$emit('remove', this.domain);
        },
        check() {
            this.$emit('check', this.domain);
        },
    },
};

</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>

.card-info {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: relative;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    padding-top: 10px;
}

.card-title {
    display: flex;
    align-items: center;
}

.card-description {
    display: flex;
    flex-direction: column;
}

.attempt {
    position: absolute;
    top: 10px;
    right: 10px;
}

.alert-circle-icon {
  color: $color-red;
    margin-right: 10px;
    margin-bottom: 20px;
    width: 50px;
    height: 40px;
}

.alert-triangle-icon {
    color: $color-orange-800;
    margin-right: 10px;
    margin-bottom: 20px;
    width: 50px;
    height: 40px;
}

.check-circle-icon {
    color: $color-green;
    margin-right: 10px;
    width: 50px;
    height: 40px;
}

.card-info-warning {
    display: flex;
    justify-content: space-between;
    border-radius: px-to-rem(8);
    background-color: #fff6df;
    font-size: .8rem;
    width: 100%;
    margin-bottom: 10px;
}

.note-box {
  margin: 10px;
}

.wrap-buttons {
    margin-left: 40px;
}

button.remove-domain-button, button.retry-domain-button {
    background-color: transparent;
    color: #0042db;
    font-family: unset;
}

#vue-content-custom-domain-mgmt > div > section:nth-child(2) > header > section {
    width: 100%;
}
</style>
